import { takeEvery } from 'redux-saga/effects';

// internal
import * as ActionType from '@app/store/typings/actions/brand.d';
import {
  fetchData,
  selectId,
  manageUserInBrand,
  deleteUserInBrand,
  fetchBrandWithId,
  fetchBrandCreateBy,
  uploadBrandPicture,
} from '@app/store/sagas/brand/data';
import { createBrand, updateBrand } from '@app/store/sagas/brand/createbrand';
import {
  listRolesInBrand,
  createRoleInBrand,
  updateRoleInBrand,
  deleteRolesInBrand,
  roleInBrandWithId,
} from '@app/store/sagas/brand/role';

export function* brandSaga() {
  yield takeEvery(ActionType.KEY_BRAND_FETCH, fetchData);
  yield takeEvery(ActionType.KEY_BRAND_FETCH_WITHID, fetchBrandWithId);
  yield takeEvery(ActionType.KEY_BRAND_SELECT_ID, selectId);
  yield takeEvery(ActionType.KEY_BRAND_CREATE, createBrand);
  yield takeEvery(ActionType.KEY_BRAND_UPDATE, updateBrand);
  yield takeEvery(ActionType.KEY_BRAND_FETCH_LISTROLES, listRolesInBrand);
  yield takeEvery(ActionType.KEY_BRAND_CREATE_ROLE, createRoleInBrand);
  yield takeEvery(ActionType.KEY_BRAND_UPDATE_ROLE, updateRoleInBrand);
  yield takeEvery(ActionType.KEY_BRAND_DELETE_ROLES, deleteRolesInBrand);
  yield takeEvery(ActionType.KEY_BRAND_MANAGE_USER, manageUserInBrand);
  yield takeEvery(ActionType.KEY_BRAND_DELETE_USER, deleteUserInBrand);
  yield takeEvery(ActionType.KEY_BRAND_ROLE_WITHID, roleInBrandWithId);
  yield takeEvery(ActionType.KEY_BRAND_CREATEBY_FETCH, fetchBrandCreateBy);
  yield takeEvery(ActionType.KEY_BRAND_UPLOAD_PICTURE, uploadBrandPicture);
}
